// 仅在本次页面运行期间传递邮箱，订阅页读取后立即清除，不写入 URL 或持久存储。
let draft = null;

export function setMailSubscriptionDraft(email, language) {
  draft = { email: email.trim(), language };
}

export function takeMailSubscriptionDraft(language) {
  const current = draft;
  draft = null;
  return current && current.language === language ? current.email : '';
}
